import { getFromLocalStorage } from "./localstorage";

export const isUserSuperAdmin = () => {
  return !!getFromLocalStorage("isSuperAdmin");
};